import { Flex, Text } from "@chakra-ui/react";
import { HeaderCard } from "./HeaderCard";

export function Card({
  title,
  razaoSocial,
  cnpj,
  ie,
  endereco,
  numero,
  complemento,
  bairro,
  cidade,
  estado,
  cep,
  telefone,
  celular,
  email,
  isGreen,
  nome,
  isHeader,
  isCard,
  entreguePor,
  saidaMercadoria,
}) {
  return (
    <>
      <HeaderCard title={title} isGreen={isGreen} />
      <Flex flexDir="column" ml="1rem" fontSize="0.9375rem" paddingBlock="1rem" gap={1}>
        {saidaMercadoria && (
          <Text as="span" fontWeight="bold">
            Saída da Mercadoria da fábrica:{" "}
            <Text as="span" fontWeight="normal">
              {saidaMercadoria}
            </Text>
          </Text>
        )}

        {entreguePor && (
          <Text as="span" fontWeight="bold">
            Entregue por:{" "}
            <Text as="span" fontWeight="normal">
              {entreguePor}
            </Text>
          </Text>
        )}

        {razaoSocial && (
          <Text as="span" fontWeight="bold">
            Razão Social:{" "}
            <Text as="span" fontWeight="normal">
              {razaoSocial}
            </Text>
          </Text>
        )}
        {cnpj && (
          <Text as="span" fontWeight="bold">
            CNPJ:{" "}
            <Text as="span" fontWeight="normal">
              {cnpj}
            </Text>
          </Text>
        )}
        {ie && (
          <Text as="span" fontWeight="bold">
            IE:{" "}
            <Text as="span" fontWeight="normal">
              {ie}
            </Text>
          </Text>
        )}
        <>
          {endereco && (
            <Text as="span" fontWeight="bold">
              Endereço:{" "}
              <Text as="span" fontWeight="normal">
                {endereco} - {numero} {complemento} - {bairro} - {cidade} - {estado}{" "}
              </Text>
            </Text>
          )}

          {cidade && (
            <Text as="span" fontWeight="bold">
              Cidade:{" "}
              <Text as="span" fontWeight="normal">
                {cidade}
              </Text>
            </Text>
          )}
          {estado && (
            <Text as="span" fontWeight="bold">
              Estado:{" "}
              <Text as="span" fontWeight="normal">
                {estado}
              </Text>
            </Text>
          )}
          {cep && (
            <Text as="span" fontWeight="bold">
              CEP:{" "}
              <Text as="span" fontWeight="normal">
                {cep}
              </Text>
            </Text>
          )}
          {nome && (
            <Text as="span" fontWeight="bold">
              Nome:{" "}
              <Text as="span" fontWeight="normal">
                {nome}
              </Text>
            </Text>
          )}
          {telefone && (
            <Text as="span" fontWeight="bold">
              Telefone:{" "}
              <Text as="span" fontWeight="normal">
                {telefone}
              </Text>
            </Text>
          )}

          {celular && (
            <Text as="span" fontWeight="bold">
              Celular:{" "}
              <Text as="span" fontWeight="normal">
                {celular}
              </Text>
            </Text>
          )}
          {email && (
            <Text as="span" fontWeight="bold">
              E-mail:{" "}
              <Text as="span" fontWeight="normal">
                {email}
              </Text>
            </Text>
          )}
        </>
      </Flex>
    </>
  );
}
